
import { parseOnlyNumericValue, removeSpecialCharAndNumFn, safeToString, sliceText } from "../../../utils/common";


const ALLOWANCE_ADD_FIELDS = [
    {
      name: "allowanceName",
      inputType: "inputField",
      component: "InputField",
      label: "Allowance Name",
      fullWidth: true,
      placeholder: "Type Here",
      customOptions: {
        formatValueFn: (value) => {
          return sliceText(removeSpecialCharAndNumFn(safeToString(value)), 150);
        },
      },
    },
    {
      name: "allowanceType",
      inputType: "selectField",
      component: "SelectField",
      label: "Type",
      fullWidth: true,
      options: [
        { value: "percentage", label: "Percentage" },
        { value: "fixed", label: "Fixed" },
      ],
      placeholder: "Type Here...",
    },
    {
      name: "allowanceValue",
      inputType: "inputField",
      component: "InputField",
      label: "Amount",
      fullWidth: true,
      placeholder: "Type Here",
      type: "text",
      customOptions: {
      
        formatValueFn:(value,allValues)=>{   
          if(allValues.allowanceType==='percentage'){

              value = sliceText(parseOnlyNumericValue(value),3);
          }else{
            value = sliceText(parseOnlyNumericValue(value),10);

          }
           return value;
         }
      },
      prefix:true,
    },
    {
      name: "noWorkNoPay",
      inputType: "selectField",
      component: "SelectField",
      label: "No Work No Pay",
      fullWidth: true,
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
      placeholder: "Type Here...",
    },
    {
      name: "isEsiWages",
      inputType: "checkbox",
      component: "Checkbox",
      label: "ESI Wages",
    },
    {
      name: "isEpfWages",
      inputType: "checkbox",
      component: "Checkbox",
      label: "EPF Wages",
    },
   
  ];
  
export const ALLOWANCE_INITIAL_STATE={
    "allowanceName": "",
  
    "allowanceType": "",
    "allowanceValue": "",
    "noWorkNoPay": "",
    "isEsiWages": false,
    "isEpfWages": false,
    status:true,
}

  export const ALLOWANCE_TABLE_HEADER = [
    {
      key: "allowanceName",
      label: "Allowance Name",
      isClickable: true,
      isShortable: true,
      isVisible: true,
      isColumnSticky: "true",

    
      
    },
    {
      key: "slug",
      label: "Slug",
      isShortable: false,
      isVisible: true,
    },
    {
      key: "allowanceType",
      label: "Allowance Type",
      isShortable: true,
      isVisible: true,
    },
    {
      key: "allowanceValue",
      label: "Allowance Value",
      align: "right",
      isShortable: true,
      isVisible: true,
    },
    {
      key: "noWorkNoPay",
      label: "No Work No Pay",
      align: "center",
      isShortable: false,
      isVisible: true,
    },
    {
      key: "isEsiWages",
      label: "ESI Wages",
      align: "center",
      isShortable: false,
      isVisible: true,
    },
    {
      key: "isEpfWages",
      label: "EPF Wages",
      align: "center",
      isShortable: false,
      isVisible: true,
    },
    {
      key: "status",
      label: "Status",
      align: "left",
      isShortable: true,
      isVisible: true,
    },
   
  ];
  
  

  export const ALLOWANCE_API={
ALLOWANCE_CREATE:{URL:"/allowance/", METHOD:"POST"},
ALLOWANCE_UPDATE:{URL:"/allowance/", METHOD:"PATCH"},
ALLOWANCE_DELETE:{URL:"/allowance/", METHOD:"DELETE"},
ALLOWANCE_LIST:{URL:"/allowance/", METHOD:"GET"},
MASTER_ALLOWANCE_LIST:{URL:"/allowance/admin/master", METHOD:"GET"},

};


export const ALLOWANCE_FIELDS={
    ALLOWANCE_ADD_FIELDS:ALLOWANCE_ADD_FIELDS
}

// src/constants/formConstants.js

export const ALLOWANCE_INPUT_FIELDS = {
  allowanceName: {
    name: "allowanceName",
    label: "Allowance Name",
    placeholder: "Type Here",

    customOptions: {
      formatValueFn: (value) => {
        return sliceText(removeSpecialCharAndNumFn(safeToString(value)), 150);
      },
    },
    required:true,
    type:"text"


  },
  allowanceType: {
    name: "allowanceType",
    label: "Type",
    options: [
      { id: "percentage", name: "Percentage" },
      { id: "fixed", name: "Fixed" },
    ],
    placeholder: "Type Here...",
    required:true
  },
  allowanceValue: {
    name: "allowanceValue",
    label: "Amount",
    placeholder: "Type Here",
    type: "text",
    customOptions: {
      
      formatValueFn:(value,allValues)=>{   
        if(allValues.allowanceType==='percentage'){

            value = sliceText(parseOnlyNumericValue(value),3);
        }else{
          value = sliceText(parseOnlyNumericValue(value),10);

        }
         return value;
       }
    },
    required:true,


  },




  
  noWorkNoPay: {
    name: "noWorkNoPay",
    label: "No Work No Pay",
    options: [
      { id: true, name: "Yes" },
      { id: false, name: "No" },
    ],
    placeholder: "Type Here...",
    required:true,
    type:"selectBox"


  },
  isEsiWages: {
    name: "isEsiWages",
    label: "ESI Wages",
    type:"checkbox"

  },
  isEpfWages: {
    name: "isEpfWages",
    label: "EPF Wages",
    type:"checkbox"
  },
};
